export default __webpack_public_path__ + "static/media/logoHorizontal.a6e2ce43.png";